import React, { useEffect, useState } from "react";
import styles from './Home.module.scss';
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import PageTitle from "../../../components/pageTitle/PageTitle";
import Filter from "../../../components/filter/Filter";
import Dropdown from "../../../components/dropdown/Dropdown";
import axiosClient from "../../../api/axiosClient";
import DashboardDirectorCard from "../../../components/dashboardDirectorCard/DashboardDirectorCard";
import Icon from "../../../components/icon/Icon";
import { useToasts } from "../../../contexts/ToastContext";

const Home = () => {
  const [specialityList, setSpecialityList] = useState([]);
  const [yearList, setYearList] = useState([]);

  const [summaryData, setSummaryData] = useState({
    totalStudents: 0,
    clinicalDayAllocations: 0,
    unAllocatedStudents: 0,
    readingDayAllocations: 0
  })
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [summaryYear, setSummaryYear] = useState(null);
  const [summaryRotation, setSummaryRotation] = useState(null);

  const [instructorData, setInstructorData] = useState({
    totalInstructors: 0,
    allocatedInstructors: 0,
    unAllocatedInstructors: 0,
    temporaryInstructors: 0
  })
  const [isInstructorLoading, setIsInstructorLoading] = useState(false);
  const [instructorYear, setInstructorYear] = useState(null);
  const [instructorRotation, setInstructorRotation] = useState(null);

  const [affiliationData, setAffiliationData] = useState({
    expired: 0,
    expiringInSixtyDays: 0,
    expiringInThirtyDays: 0,
    uptoDate: 0
  })
  const [isAffiliationLoading, setIsAffiliationLoading] = useState(false);
  const [category, setCategory] = useState("HealthSystems");

  const [attendanceData, setAttendanceData] = useState({
    defaulters: 0,
    totalClockIn: 0,
    totalClockOut: 0,
  })
  const [isAttendanceLoading, setIsAttendanceLoading] = useState(false);
  const [attendanceYear, setAttendanceYear] = useState(null);
  const [attendanceRotation, setAttendanceRotation] = useState(null);

  const [evaluationData, setEvaluationData] = useState({
    pastDue: 0,
    pending: 0,
    submitted: 0,
    totalEvaluations: 0,
  })
  const [isEvaluationLoading, setIsEvaluationLoading] = useState(false);
  const [evaluationYear, setEvaluationYear] = useState(null);
  const [evaluationRotation, setEvaluationRotation] = useState(null);

  const [caseData, setCaseData] = useState({
    pastDue: 0,
    pending: 0,
    submitted: 0,
    submittedLate: 0,
  })
  const [isCaseLoading, setIsCaseLoading] = useState(false);
  const [caseYear, setCaseYear] = useState(null);
  const [caseRotation, setCaseRotation] = useState(null);

  const [complianceData, setComplianceData] = useState({
    nonCompliant: 0,
    pending: 0,
    uptoDate: 0,
  })
  const [isComplianceLoading, setIsComplianceLoading] = useState(false);
  const [complianceYear, setComplianceYear] = useState(null);

  const [programData, setProgramData] = useState({
    total: 0,
    active: 0,
    inactive: 0,
  })
  const [isProgramLoading, setIsProgramLoading] = useState(false);
  const [programYear, setProgramYear] = useState(null);


  const { showToast } = useToasts();

  useEffect(() => {
    const fetchData = async () => {
      axiosClient.get('specialities')
      .then ((specialityResponse) => {
        setSpecialityList(specialityResponse.data.map((item) => ({
          value: item.id,
          label: item.name
        })));
      })
      await axiosClient.get(`years/details`)
      .then((response) => {
        setYearList(response.data.map((item) => ({
          value: item.year.id,
          label: item.year.year
        })));
      })
      .catch((error) => { showToast(error.message, 'error'); })
    };

    fetchData();
  }, [showToast]);

 
  
  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(summaryYear) {
        params.yearId = summaryYear;
      }
      if(summaryRotation) {
        params.specialityId = summaryRotation;
      }
      setIsSummaryLoading(true);
      await axiosClient.get(`dashboard/admin-director/student-summary`, {
        params: params
      })
      .then((response) => {
        setSummaryData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsSummaryLoading(false);
      });
    };

    fetchData();
  }, [summaryYear, summaryRotation, showToast]);

   //instructor data fetching

  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(instructorYear) {
        params.yearId = instructorYear;
      }
      if(instructorRotation) {
        params.specialityId = instructorRotation;
      }
      setIsInstructorLoading(true);
      await axiosClient.get(`dashboard/admin-director/instructor-summary`, {
        params: params
      })
      .then((response) => {
        setInstructorData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsInstructorLoading(false);
      });
    };

    fetchData();
  }, [instructorYear, instructorRotation, showToast]);

//fetch affiliation data
  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(category) {
        params.filter = category;  
      }
      setIsAffiliationLoading(true);
      await axiosClient.get(`dashboard/admin-director/affiliation-agreement-management`, {
        params: params
      })
      .then((response) => {
        setAffiliationData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsAffiliationLoading(false);
      });
    };

    fetchData();
  }, [category,showToast]);

//fetch attendance data
  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(attendanceYear) {
        params.yearId = attendanceYear;
      }
      if(attendanceRotation) {
        params.specialityId = attendanceRotation;
      }
      setIsAttendanceLoading(true);
      await axiosClient.get(`dashboard/admin-director/student-attendance`, {
        params: params
      })
      .then((response) => {
        setAttendanceData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsAttendanceLoading(false);
      });
    };

    fetchData();
  }, [attendanceYear, attendanceRotation, showToast]);

  //fetch evaluation data

  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(evaluationYear) {
        params.yearId = evaluationYear;
      }
      if(evaluationRotation) {
        params.specialityId = evaluationRotation;
      }
      setIsEvaluationLoading(true);
      await axiosClient.get(`dashboard/admin-director/evaluation-summary`, {
        params: params
      })
      .then((response) => {
        setEvaluationData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsEvaluationLoading(false);
      });
    };

    fetchData();
  }, [evaluationYear,evaluationRotation, showToast]);

  //fetch caselog data

  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(caseYear) {
        params.yearId = caseYear;
      }
      if(caseRotation) {
        params.specialityId = caseRotation;
      }
      setIsCaseLoading(true);
      await axiosClient.get(`dashboard/admin-director/case-log-summary`, {
        params: params
      })
      .then((response) => {
        setCaseData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsCaseLoading(false);
      });
    };

    fetchData();
  }, [caseYear,caseRotation, showToast]);

  //fetch student compliance data

  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(complianceYear) {
        params.yearId = complianceYear;
      }
      setIsComplianceLoading(true);
      await axiosClient.get(`dashboard/admin-director/student-compliance`, {
        params: params
      })
      .then((response) => {
        setComplianceData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsComplianceLoading(false);
      });
    };

    fetchData();
  }, [complianceYear, showToast]);

  //fetch program summary data

  useEffect(() => {
    const fetchData = async () => {
      let params = {};
      if(programYear) {
        params.yearId = programYear;
      }
      setIsProgramLoading(true);
      await axiosClient.get(`dashboard/admin-director/program-summary`, {
        params: params
      })
      .then((response) => {
        setProgramData(response.data);
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsProgramLoading(false);
      });
    };

    fetchData();
  }, [programYear, showToast]);

  return (
    <>
      <div className={styles.header}>
        <PageTitle
          label="Home"
        />
      </div>
      <div className={styles.container}>
        <div className={styles.section}>
          {isSummaryLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2>Student Summary</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={summaryYear}
                  onChange={(filter) => {
                    setSummaryYear(filter);
                  }}
                />
              </div>
            </div>
            <div className={styles.dropdown}>
              <Dropdown
                label="Rotation"
                options={[
                  {
                    value: null,
                    label: 'All Rotations'
                  },
                  ...specialityList
                ]}
                value={summaryRotation}
                onChange={(value) => {
                  setSummaryRotation(value);
                }}
              />
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Students"
                type="BlueBG"
                count={{
                  count: summaryData.totalStudents
                }}
                showIcon={true}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Clinical Day Allocation"
                type="Green"
                count={{
                  count: summaryData.clinicalDayAllocations
                }}
                showIcon={true}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Unallocated Students"
                type="Red"
                count={{
                  count: summaryData.unAllocatedStudents
                }}
                showIcon={true}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Reading Day Allocation"
                type="Orange"
                count={{
                  count: summaryData.readingDayAllocations
                }}
                showIcon={true}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isInstructorLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2>Instructor Summary</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={instructorYear}
                  onChange={(filter) => {
                    setInstructorYear(filter);
                  }}
                />
              </div>
            </div>
            <div className={styles.dropdown}>
              <Dropdown
                label="Rotation"
                options={[
                  {
                    value: null,
                    label: 'All Rotations'
                  },
                  ...specialityList
                ]}
                value={instructorRotation}
                onChange={(value) => {
                  setInstructorRotation(value);
                }}
              />
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Instructors"
                type="BlueBG"
                count={{
                  count: instructorData.totalInstructors
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Allocated Instructors"
                type="Green"
                count={{
                  count: instructorData.allocatedInstructors
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Unallocated Instructors"
                type="Red"
                count={{
                  count: instructorData.unAllocatedInstructors
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Temporary Instructors"
                type="Orange"
                count={{
                  count: instructorData.temporaryInstructors
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isAffiliationLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2>Affiliation Agreement Management</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'Health Systems',
                      value: 'HealthSystems'
                    },
                    {
                      label: 'Clinical Sites',
                      value: 'ClinicalSites'
                    }
                  ]}
                  selected={category}   
                  onChange={(filter) => {
                    setCategory(filter);
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Up to Date"
                type="GreenBG"
                count={{
                  count: affiliationData.uptoDate,
                  showIcon: true
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Expiring in 60 Days"
                type="BlueBG"
                count={{
                  count: affiliationData.expiringInSixtyDays,
                  showIcon: true
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Expiring in 30 Days"
                type="OrangeBG"
                count={{
                  count: affiliationData.expiringInThirtyDays,
                  showIcon: true
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Expired"
                type="Red"
                count={{
                  count: affiliationData.expired,
                  showIcon: true
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isAttendanceLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2><Icon name="clock" /> Today’s Attendance</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={attendanceYear}
                  onChange={(filter) => {
                    setAttendanceYear(filter);
                  }}
                />
              </div>
            </div>
            <div className={styles.dropdown}>
              <Dropdown
                label="Rotation"
                options={[
                  {
                    value: null,
                    label: 'All Rotations'
                  },
                  ...specialityList
                ]}
                value={attendanceRotation}
                onChange={(value) => {
                  setAttendanceRotation(value);
                }}
              />
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Clock-In"
                type="Blue"
                count={{
                  count: attendanceData.totalClockIn
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Clock-Out"
                type="Green"
                count={{
                  count: attendanceData.totalClockOut
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Defaulters"
                type="Red"
                count={{
                  count: attendanceData.defaulters
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isEvaluationLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2><Icon name="clipboard" /> Evaluation Summary</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={evaluationYear}
                  onChange={(filter) => {
                    setEvaluationYear(filter);
                  }}
                />
              </div>
            </div>
            <div className={styles.dropdown}>
              <Dropdown
                label="Rotation"
                options={[
                  {
                    value: null,
                    label: 'All Rotations'
                  },
                  ...specialityList
                ]}
                value={evaluationRotation}
                onChange={(value) => {
                  setEvaluationRotation(value);
                }}
              />
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Evaluations"
                type="Blue"
                count={{
                  count: evaluationData.totalEvaluations
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Pending"
                type="Orange"
                count={{
                  count: evaluationData.pending
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Submitted"
                type="Green"
                count={{
                  count: evaluationData.submitted
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Past Due"
                type="Red"
                count={{
                  count: evaluationData.pastDue
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isCaseLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2><Icon name="file-text" /> Case Log Summary</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={caseYear}
                  onChange={(filter) => {
                    setCaseYear(filter);
                  }}
                />
              </div>
            </div>
            <div className={styles.dropdown}>
              <Dropdown
                label="Rotation"
                options={[
                  {
                    value: null,
                    label: 'All Rotations'
                  },
                  ...specialityList
                ]}
                value={caseRotation}
                onChange={(value) => {
                  setCaseRotation(value);
                }}
              />
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Submitted"
                type="Blue"
                count={{
                  count: caseData.submitted
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Pending"
                type="Orange"
                count={{
                  count: caseData.pending
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Past Due"
                type="Red"
                count={{
                  count: caseData.pastDue
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Submitted Late"
                type="Red"
                count={{
                  count: caseData.submittedLate
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
        {isComplianceLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2><Icon name="clipboard" /> Student Compliance</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={complianceYear}
                  onChange={(filter) => {
                    setComplianceYear(filter);
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Up to Date"
                type="Green"
                count={{
                  count: complianceData.uptoDate
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Pending"
                type="Orange"
                count={{
                  count: complianceData.pending
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Non-Compliant"
                type="Red"
                count={{
                  count: complianceData.nonCompliant
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
          {isProgramLoading && <LoadingOverlay />}
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitle}>
              <h2>Program Summary</h2>
              <div className={styles.filter}>
                <Filter
                  filters={[
                    {
                      label: 'All',
                      value: null
                    },
                    ...yearList
                  ]}
                  selected={programYear}
                  onChange={(filter) => {
                    setProgramYear(filter);
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.cardList}>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Total Programs"
                type="BlueBG"
                count={{
                  count: programData.total
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Active Programs"
                type="Green"
                count={{
                  count: programData.active
                }}
              />
            </div>
            <div className={styles.cardItem}>
              <DashboardDirectorCard
                title="Inactive Programs"
                type="Red"
                count={{
                  count: programData.inactive
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;